import { render } from "./face_2.svg?vue&type=template&id=20224c69"
const script = {}
script.render = render

export default script